import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '$store';
import Loader from '~components/generic/loader/Loader';
import useAppDispatch from '~hooks/useAppDispatch';
import { removeAssetThunk, setNextStep } from '~modules/media-library/controller/thunks/contribute';
import useAssetActions from '~modules/media-library/controller/useAssetActions';
import { AssetId } from '~modules/media-library/model/Asset';
import Uploader from '~modules/media-library/view/Contribute/UploadAssetsForm/Uploader/Uploader';
import ItemUpload from '~modules/media-library/view/Contribute/UploadAssetsForm/UploadItem';
import styles from './UploadAssetsForm.module.css';

/**
 * UploadAssetsForm component
 */

interface UploadAssetsFormProps {
  onClose?: () => void;
}

export function UploadAssetsForm({ onClose }: UploadAssetsFormProps) {
  const data = useSelector((store: RootState) => store.contribute);

  const dispatch = useAppDispatch();

  const { uploadsCompleted, allFiles, processCanStart, contributionMode, uploadInProgress } = data;

  const assetActions = useAssetActions();
  useEffect(() => {
    if (uploadsCompleted) assetActions.onUploadSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadsCompleted]);

  const handleDelete = (id: AssetId) => {
    dispatch(removeAssetThunk(id));
  };

  return (
    <div className={styles.uploadAssetsFormContainer}>
      {uploadInProgress && (
        <div className={styles.overlay}>
          <Loader absoluteCenter theme="dark" />
        </div>
      )}
      <header className="ml--detail-modal--panel-header flex pl-3 py-2 pr-8 ">
        <h2 className="ml--detail-modal--title font-semibold text-base leading-snug overflow-hidden overflow-ellipsis p-0 m-0 h-10 clamp-2 ">
          Upload
        </h2>
      </header>
      <div className={styles.uploadItemsContainer}>
        <Uploader multiple={contributionMode === 'new'} />
        {allFiles.map((file, key) => (
          <ItemUpload handleDelete={() => handleDelete(file.id)} key={key} file={file} />
        ))}
        {contributionMode === 'new' && (
          <div className={styles.buttonContainer}>
            <button className="button c-button c-button--light u-padding-horizontal-lg mr-2" onClick={onClose}>
              Close
            </button>
            <button
              disabled={!processCanStart}
              className="button c-button c-button--dark  u-padding-horizontal-lg mx-2"
              onClick={() => dispatch(setNextStep())}
            >
              Start Process
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
